import { Component, Input, OnInit, input } from '@angular/core';
import { ZiroFormAbstractDirective } from '../../../../../../../../forms/ziro-form-abstract.directive';
import { ZiroFormConfig } from '../../../../../../../../forms/ziro-forms-models';
import { Observable, of } from 'rxjs';
import { ZiroFormStateService } from '../../../../../../../../forms/ziro-form-state.service';
import { ZiroIcons } from '../../../../../../../../shared/models/ziro-icons.enum';

export interface HelpdeskEntraAttributesEntity {
  [key: string]: string;
}

@Component({
  selector: 'ziro-helpdesk-entra-attributes-form',
  templateUrl: './helpdesk-entra-attributes-form.component.html',
  standalone: false,
})
export class HelpdeskEntraAttributesFormComponent
  extends ZiroFormAbstractDirective<HelpdeskEntraAttributesEntity>
  implements OnInit
{
  protected _ziroFormStateService: ZiroFormStateService;

  // TODO: Skipped for migration because:
  //  This input overrides a field from a superclass, while the superclass field
  //  is not migrated.
  @Input() formConfig: ZiroFormConfig;
  attributeFields = input<string[]>();
  hiddenFields: string[] = [];
  ziroIcons = ZiroIcons;

  ngOnInit(): void {
    this.hiddenFields = this.attributeFields().filter(
      (fieldId) =>
        this.formConfig.fields[fieldId].hidden() &&
        this.entity[fieldId] === this.formConfig.fields[fieldId].defaultValue(),
    );
  }

  protected submit(): Observable<any> {
    return of(null);
  }
}
